import React, { ReactNode } from "react";

import { TarotContent } from "features/無料占いコンテンツ/components/templates/TarotContent";
import Layout from "components/layout";
import { GetStaticPaths, GetStaticProps } from "next";
import { repository } from "repositories";
import { handleServerSideError } from "shared/utils/ssr";
import { FreeFortuneContent } from "shared/types";
import { AppHeader } from "components/layout/Header";
import { FreeFortuneProvider } from "features/無料占いコンテンツ/context";

interface Props {
  freeFortuneContent: FreeFortuneContent;
}

const FreeFortuneTarot = ({ freeFortuneContent }: Props) => {
  return (
    <FreeFortuneProvider content={freeFortuneContent}>
      <TarotContent content={freeFortuneContent} />
    </FreeFortuneProvider>
  );
};

FreeFortuneTarot.getLayout = (page: ReactNode) => {
  return <Layout header={<AppHeader></AppHeader>}>{page}</Layout>;
};

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  try {
    const data = await repository.freeFortuneContent
      .getObject(ctx.params.id)
      .data();

    return {
      props: {
        freeFortuneContent: data?.freeFortuneContent,
      },
    };
  } catch (error) {
    return handleServerSideError(error);
  }
};

export default FreeFortuneTarot;
